var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feather Icons / upload-cloud",
    clipPath: "url(#clip0_131_2255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8332 13.3333L10.4998 10L7.1665 13.3333",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 10V17.5",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.4919 15.3249C18.3047 14.8818 18.9467 14.1806 19.3168 13.3321C19.6868 12.4835 19.7637 11.5359 19.5354 10.6388C19.307 9.7417 18.7865 8.94616 18.0558 8.37778C17.3251 7.80939 16.4259 7.50052 15.5002 7.4999H14.4502C14.198 6.52427 13.7278 5.61852 13.0752 4.85073C12.4225 4.08295 11.6042 3.47311 10.682 3.06708C9.75967 2.66104 8.75734 2.46937 7.75031 2.50647C6.74328 2.54358 5.75777 2.80849 4.86786 3.28129C3.97795 3.7541 3.2068 4.42249 2.6124 5.23622C2.01799 6.04996 1.61579 6.98785 1.43603 7.9794C1.25627 8.97095 1.30363 9.99035 1.57456 10.961C1.84548 11.9316 2.33291 12.8281 3.00021 13.5832",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.8332 13.3333L10.4998 10L7.1665 13.3333",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_2255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.660ba3648d0efc5653052f2c7a9af6e9.svg";
export { ForwardRef as ReactComponent };